import { IHasFrameContext } from "UI/UI/UI/Controls/ControlInterfaces";
import { IKeyValueItem } from "../../../../../../Global/Base/DataSources/Interfaces";
import { IAttrStringValue } from "../../../../../../Global/Base/DataTypes/IAttrValue";
import { Event } from "../../../../../../Global/Base/Events";
import { Localization } from "../../../../../../OW.Remoting/Remoting/Localization";
import { Control } from "../../../../../UI.BaseControls/Control";
import { IValidatable, IValidationResult } from "../../../../../UI.BaseControls/ControlInterfaces";
import { GenericControl } from "../../../../../UI.BaseControls/GenericControl";
import { DropDownButtonItem } from "../../../../../UI.Controls/DropDownMenu/DropDownButtonItem";
import { DropDownMenu } from "../../../../../UI.Controls/DropDownMenu/DropDownMenu";
import { createElement, registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { FrameContext } from "../../../UIManagerInterfaces";
import { DropDownMenuCheckedDGItem } from "../DropDownMenuItems/DropDownMenuCheckedDGItem";
import { FilterBlock } from "../FilterBlock";
import { FilterGroup } from "../FilterGroup";
import { IKeyValueItemExtended } from "./ValueList";

export class ValueListButton extends Control implements IValidatable, IHasFrameContext {
    public validityChanged: Event<IValidatable, IValidationResult> = new Event<IValidatable, IValidationResult>();
    public currentValidity: IValidationResult;
    public isInRequiredInvalidState: boolean;

    private _isValid = false;

    public get isValid(): boolean {
        return this._isValid;
    }
    protected _valueList: DropDownMenuCheckedDGItem;
    protected _menu: DropDownMenu;
    protected _appendValueSection: HTMLElement;
    protected _selectedItems: Array<IKeyValueItem>;
    protected _init: boolean;
    public frameContext: FrameContext | undefined = undefined;

    public get value(): any {
        return this._selectedItems;
    }

    public set value(v: any) {
        if (v instanceof IKeyValueItem)
            this._selectedItems = [v];
        else if (v instanceof Array) {
            this._selectedItems = [];
            for (const v1 of v) {
                this._selectedItems.push(v1 instanceof IKeyValueItem ? v1 : v1 instanceof IAttrStringValue ?
                    { key: v1.valueOf(), value: v1.valueOf(), shortenedValue: v1.shortened } as IKeyValueItemExtended : { value: v1, key: v1 });
            }
        } else
            this._selectedItems = v;

        this._appendSelectedValue();
    }

    public validate(): boolean {
        if (this._selectedItems.length == 0) this.setInvalid("GUI-55627");
        else this.setValid();

        return this._isValid;
    }
    public setValid(): void {
        if (this._isValid)
            return;

        this._isValid = true;

        this.validityChanged.trigger(this, { valid: true });
    }
    public setInvalid(_locKey: string, _message?: string): void {
        if (!this._isValid)
            return;

        this._isValid = false;

        this.validityChanged.trigger(this, { valid: false });
    }

    public async loadItems(): Promise<void> {
        if (this._init)
            return;
        this._init = true;
        const fgroup = GenericControl.findParent(this as HTMLElement, (item) => item instanceof FilterGroup);
        this._valueList = new DropDownMenuCheckedDGItem();

        if (fgroup instanceof FilterGroup) {
            this.initializeValueList(fgroup);
            (fgroup.parent as FilterBlock).frameConditionChanged.add((_sender, value) => {
                this._reloadItems(value);
            });
        }

        this._menu.addItem(this._valueList);
        this._valueList.valueList.selectedValues = this._selectedItems;

        const m = new DropDownButtonItem();
        m.addItem("GUI-311684", () => { // Vybrat
            /*V případě že se jedná o zkrácenou hodnotu, je potřeba ji brát z klíče, tam je totiž hodnota bez přidaných tří teček. Nemám teď jinou možnost jak z ValueListu
             * získat původní hodnotu. */
            this._selectedItems = this._valueList.valueList.selectedValues.map((v) => {
                if (v instanceof IKeyValueItemExtended && v.shortenedValue)
                    v.value = v.key;

                return v;
            });

            this._appendSelectedValue();

            m.parent.close();

            this.callEvent("change");
        });

        this._menu.addItem(m);
    }

    protected initializeValueList(fgroup: FilterGroup): void {
        this._valueList.init(fgroup.parent.objectName, [fgroup.attrName], this.frameContext, fgroup.parent.frameCondition, fgroup.parent.frameConditionParams, fgroup.parent.disableValueShortening);
    }

    private async _reloadItems(frameCondition: string): Promise<void> {
        this._selectedItems = [];
        this._valueList.valueList.changeFrameConditionAndLoad(frameCondition);
    }

    //public unselectedAll() {
    //    this._selectedItems = [];

    //    for (let item of this._selectedItems) {
    //        if (item instanceof DropDownMenuCheckboxItem) {
    //            item.IsChecked = false;
    //        }
    //    }

    //    this.appendValueSection.innerHTML = "";
    //}

    protected _appendSelectedValue(): void {
        this._appendValueSection.innerHTML = "";

        // kompatibilita z duvodu starych profilu - drive to byl string, ted je to pole stringu, tohle zparsuje stary string na nove pole
        if (typeof this._selectedItems === "string") {
            this._selectedItems = (this._selectedItems as string).split(",").map((item) => {
                let s = item.trim();
                if (s.startsWith("'")) {
                    s = s.substr(1);
                } if (s.endsWith("'")) {
                    s = s.substr(s.length - 1);
                }
                return s as any as IKeyValueItem;
            });
        }

        for (const si of this._selectedItems) {
            const exist = this._appendValueSection.querySelector(`[data-id='${si}']`); // `
            if (exist != null)
                continue;

            const item = createElement({
                classes: "FilterValue",
                attrs: { "data-id": si.key },
            });

            const rem = createElement({ classes: "Icon Remove" });
            const span = createElement({ type: "span" });

            this.renderElement(span, si);

            rem.addEventListener("click",
                () => {
                    let i = 0;
                    for (const it of this._selectedItems) {
                        if (it == si) {
                            break;
                        }
                        i++;
                    }
                    this._valueList.valueList.removeSelectedValue(this._selectedItems[i].key);
                    item.remove();
                });
            item.appendChild(span);
            item.appendChild(rem);

            this._appendValueSection.appendChild(item);
        }
    }

    protected renderElement(span: HTMLElement, selectedItem: IKeyValueItem): void {
        span.textContent = selectedItem.value;
    }

    protected override _constructor(): void {
        super._constructor();

        this._selectedItems = [];
        const btnSection = createElement({ classes: "BtnSection" });
        const icon = createElement({ classes: "Icon FilterMultiItem" });
        const arrow = createElement({ classes: "icon ui-chevron-bottom arrow-down-btn" });
        const text = createElement({ type: "span", classes: "Text", value: "Zobrazit seznam hodnot", attrs: { "data-lkd": "GUI-620639" } });
        this._appendValueSection = createElement({ classes: "AppendValueSection" });

        Localization.addLocData(text, "GUI-620639");

        btnSection.appendChild(icon);
        btnSection.appendChild(arrow);
        arrow.appendChild(text);

        this.appendChild(btnSection);
        this.appendChild(this._appendValueSection);

        this._menu = new DropDownMenu();

        // ReSharper disable once Html.EventNotResolved
        this._menu.addEventListener("open", () => {
            // Prázdná arrow funkce
        });

        btnSection.addEventListener("click", (e) => {
            this._valueList.valueList.selectedValues = this._selectedItems;
            this._menu.show(btnSection, e);
        });
    }

    protected override connectedCallback(): void {
        super.connectedCallback();

        this.loadItems();
    }

    protected override disconnectedCallback(): void {
        this._menu.close();
    }
}

registerCustomElement("tsc-ValueListButton", ValueListButton);
